PJQ.collections.drawings = {};

PJQ.models.drawings = {};

PJQ.views.drawings = {};

//Routes
PJQ.modules.drawings = {
    routes: [
        {
            route: 'projects/:projectId/drawings',
            name: 'drawings',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "drawings");
            }
        },
        {
            route: 'projects/:projectId/drawings/:versionId',
            name: 'drawings',
            callback: function (projectId, versionId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "drawings", {
                    versionId: versionId
                });
            }
        },
        {
            route: 'drawings/share/:accessKey',
            name: 'shareDrawings',
            callback: function (accessKey) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'drawings'
                        },
                        {
                            endpoint: 'share',
                            value: accessKey
                        }
                    ])
                }).get().success(_.bind(function (data) {
                    let versions = new PJQ.collections.drawings.Versions(data.versions),
                        attachments = new PJQ.collections.files.Files(data.attachments),
                        hasDrawings = _.find(versions.models, function (version) {
                            return _.size(version.drawings.models) > 0;
                        }) != null, prj;

                    if (data.projectId > 0) {
                        prj = new PJQ.models.projects.Project({
                            projectId: data.projectId
                        });
                    } else {
                        prj = null;
                    }

                    if (_.size(attachments.models) === 0 && !hasDrawings) {
                        let tmp = new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'share-not-available');
                        PJQ.templating.TemplateRenderer.renderTemplate(false, tmp, PJQ.app.$el);
                    } else {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'orders'
                                },
                                {
                                    endpoint: 'settings'
                                }
                            ])
                        }).get().done(_.bind(function (settings) {
                            let $container = $('<div>', {
                                class: 'p-3'
                            });
                            PJQ.app.$el.html($container);
                            if (_.size(attachments.models) > 0 || settings.downloadPerFileFee > 0) {
                                versions.createPsuedoFolders(attachments);

                                _.each(attachments.models, function (attachment) {
                                    if (attachment.get('isFolder'))
                                        attachment.isFetched = true;
                                });

                                PJQ.app.view.renderView(PJQ.views.projects.Attachments, {
                                    el: $container,
                                    project: prj,
                                    collection: attachments,
                                    forShare: true,
                                    isAdmin: false,
                                    orderSettings: settings,
                                    accessKey: accessKey
                                });
                            } else {
                                PJQ.app.view.renderView(PJQ.views.drawings.Dashboard, {
                                    el: $container,
                                    project: prj,
                                    collection: versions,
                                    forShare: true,
                                    orderSettings: settings,
                                    accessKey: accessKey
                                });
                            }
                        }, this));
                    }

                }, this)).fail(_.bind(function (data) {
                    if (data.responseJSON.message == 'BUSY') {
                        PJQ.app.$el.html(`
							<div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
								<div>
									<div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
									<div class="fs-36">Drawing Share Unavailable</div>
									<div class="fs-24">Files for this project are currently being processed.<br />Please try again later.</div>
								</div>
							</div>
						`);
                    } else if (data.responseJSON.message == 'OFFLINE') {
                        PJQ.app.$el.html(`
							<div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
								<div>
									<div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
									<div class="fs-36">Drawing Share Unavailable</div>
									<div class="fs-24">This project is currently unavailable for download.<br />Please try again later, or check with the sender if the issue persists.</div>
								</div>
							</div>
						`);
                    } else {
                        PJQ.app.$el.html(`
							<div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
								<div>
									<div><i class="fal fa-clock fa-9x text-orange mb-2"></i></div>
									<div class="fs-36">Drawing Share Expired</div>
									<div class="fs-24">This drawing share has expired and can no longer be viewed</div>
								</div>
							</div>
						`);
                    }
                }, this));
            }
        }
    ]
};

PJQ.constants.drawings = {
    dashboardModes: {
        VIEW: 'VIEW',
        EDIT: 'EDIT',
        SELECT: 'SELECT'
    },
    downloadStatus: {
        FAILED: -1,
        NEW: 0,
        QUEUED: 1,
        IN_PROGRESS: 2,
        COMPLETE: 3
    },
    downloadFrameId: 'pjqDownload',
    imageExtensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
    annotationTypes: {
        INSPECT: 'INSPECT',
        PEN: 'PEN',
        HIGHLIGHTER: 'HIGHLIGHTER',
        LINE: 'LINE',
        ARROW: 'ARROW',
        RECTANGLE: 'RECT',
        ELLIPSE: 'ELLIPSE',
        CLOUD: 'CLOUD',
        LINK_RECTANGLE: 'LINK_RECT',
        LINK_ELLIPSE: 'LINK_ELLIPSE',
        LINK_CLOUD: 'LINK_CLOUD',
        TEXT: 'TEXT',
        PHOTO: 'PHOTO',
        RULER: 'RULER',
        AREA_RECT: 'AREA_RECT',
        RULER_FREE_FORM: 'RULER_FREE_FROM',
        AREA_FREE_FORM: 'AREA_FREE_FORM',
        CALIBRATION: 'CALIBRATION',
        PIN_PUNCH_LIST_ITEM: 'PIN_PUNCH_LIST_ITEM',
        PIN_ACTION_ITEM: 'PIN_ACTION_ITEM',
        PIN_RFI: 'PIN_RFI',
        PIN_SUBMITTAL: 'PIN_SUBMITTAL'
    },
    annotationTypeNames: {
        INSPECT: 'Inspect/Select',
        LINE: 'Line',
        PEN: 'Pen',
        HIGHLIGHTER: 'Highlighter',
        ARROW: 'Arrow',
        RECTANGLE: 'Rectangle',
        ELLIPSE: 'Ellipse',
        CLOUD: 'Cloud',
        LINK_RECTANGLE: 'Rectangle Link',
        LINK_ELLIPSE: 'Ellipse Link',
        LINK_CLOUD: 'Cloud Link',
        TEXT: 'Text Box',
        PHOTO: 'Photo',
        RULER: 'Ruler',
        AREA_RECT: 'Area Rectangle',
        RULER_FREE_FORM: 'Free Form Ruler',
        AREA_FREE_FORM: 'Free Form Area',
        CALIBRATION: 'Calibration',
        PIN_PUNCH_LIST_ITEM: 'Punch List Item',
        PIN_ACTION_ITEM: 'Action Item',
        PIN_RFI: 'RFI',
        PIN_SUBMITTAL: 'Submittal'
    },
    refTypes: {
        DRAWING: 'DRAWING',
        PUNCH_LIST_ITEM: 'PUNCH',
        ACTION_ITEM: 'ACTION',
        RFI: 'RFI',
        SUBMITTAL: 'SUBMITTAL'
    },
    dragPoints: {
        START: 'START',
        END: 'END',
        TOP_LEFT: 'TL',
        TOP_RIGHT: 'TR',
        BOTTOM_LEFT: 'BL',
        BOTTOM_RIGHT: 'BR'
    },
    scaleTypes: {
        IMPERIAL: 'IMPERIAL',
        METRIC: 'METRIC'
    }
};

PJQ.app.addRoutes(PJQ.modules.drawings.routes);